"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useLocalStorage = (key) => {
    const prevRef = react_1.default.useRef();
    const getValue = (initialValue) => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            return initialValue;
        }
    };
    const useSetValue = (value) => {
        react_1.default.useEffect(() => {
            // Don't write anything to local storage if undefined is passed in
            if (value === undefined) {
                return;
            }
            // Since the value is saved as json, it seems reasonable to compare it as json
            const valueString = JSON.stringify(value);
            if (valueString != prevRef.current) {
                try {
                    window.localStorage.setItem(key, valueString);
                }
                catch (error) {
                    /* Don't do anything if the set fails */
                }
                prevRef.current = valueString;
            }
        }, [value]);
    };
    return [getValue, useSetValue];
};
exports.default = useLocalStorage;
//# sourceMappingURL=useLocalStorage.js.map